import script from "./CompanyAcounts.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyAcounts.vue?vue&type=script&setup=true&lang=js"

import "./CompanyAcounts.vue?vue&type=style&index=0&id=4863a986&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4863a986"]])

export default __exports__